import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ShoppingCart, Calendar, Archive } from 'lucide-react';
export function WhatInsideSection() {
  const items = [{
    icon: BookOpen,
    title: 'El Manual Maestro',
    desc: 'Paso a paso para dominar tu cocina y las 3 bases fundamentales.'
  }, {
    icon: ShoppingCart,
    title: 'Lista de Compras USA',
    desc: "Optimizada para Walmart, Costco y Trader Joe's (ahorra dinero real)."
  }, {
    icon: Calendar,
    title: 'El Calendario "Cero Estrés"',
    desc: 'Qué sacar del freezer y cómo ensamblar cada noche sin pensar.'
  }, {
    icon: Archive,
    title: 'Guía de Almacenamiento',
    desc: "Para que tu comida sepa a 'recién hecha' el jueves igual que el lunes."
  }];
  return <section className="py-20 bg-warm-white" data-id="element-161">
      <div className="container mx-auto px-4" data-id="element-162">
        <div className="text-center mb-16" data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-bold text-espresso mb-4 font-serif" data-id="element-164">
            ¿Qué incluye la guía?
          </h2>
          <p className="text-gray-600" data-id="element-165">
            Todo lo que necesitas para recuperar tu tiempo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-166">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-sm border border-stone-100 hover:shadow-md transition-shadow" data-id="element-167">
              <div className="bg-terracotta/10 p-3 rounded-lg shrink-0" data-id="element-168">
                <item.icon className="h-6 w-6 text-terracotta" data-id="element-169" />
              </div>
              <div data-id="element-170">
                <h3 className="text-xl font-bold text-espresso mb-2 font-serif" data-id="element-171">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-172">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}